import {
  SECTION_1_TABLE_NAMES_V1 as SECTION_1_TABLE_NAMES,
  SECTION_2_TABLE_NAMES_V1 as SECTION_2_TABLE_NAMES,
  SECTION_3_TABLE_NAMES_V1 as SECTION_3_TABLE_NAMES,
  SECTION_4_TABLE_NAMES_V1 as SECTION_4_TABLE_NAMES
} from './tableNames';

export const fundsSections = [
  {
    name: 'Section 1b',
    id: '1b',
    key: '1b',
    questions: [
      {
        name: '0. Filing type',
        tableName: SECTION_1_TABLE_NAMES.FILING_TYPE
      },
      {
        name: '5. Fund identifiers',
        tableName: SECTION_1_TABLE_NAMES.FUND_INFO
      },
      {
        name: '6. Master Fund',
        tableName: SECTION_1_TABLE_NAMES.MASTER_FEEDER_ARRANGEMENT
      },
      {
        name: '7. Parallel Fund Structure',
        tableName: SECTION_1_TABLE_NAMES.PARALLEL_FUNDS
      },
      {
        name: '7. Parallel Fund Structure',
        tableName: SECTION_1_TABLE_NAMES.PARALLEL_FUND_DETAILS
      },
      {
        name: '8. Gross Asset Value',
        tableName: SECTION_1_TABLE_NAMES.GROSS_ASSET
      },
      {
        name: '9. Net Asset Value',
        tableName: SECTION_1_TABLE_NAMES.NET_ASSET
      },
      {
        name: '10. Investments in External Private Funds',
        tableName: SECTION_1_TABLE_NAMES.EQUITY_VALUE_OTHER_FUNDS
      },
      {
        name: '11. Parallel Managed Accounts',
        tableName: SECTION_1_TABLE_NAMES.PARALLEL_MANAGED_ACCOUNTS
      },
      {
        name: '12. Borrowings',
        tableName: SECTION_1_TABLE_NAMES.BORROWINGS_AND_OTHER_CREDITORS
      },
      {
        name: '13. Derivatives Positions',
        tableName: SECTION_1_TABLE_NAMES.OUTSTANDING_DERIVATIVES
      },
      {
        name: '14. Fair Value',
        tableName: SECTION_1_TABLE_NAMES.FUND_ASSETS_AND_LIABILITIES_VALUE
      },
      {
        name: '15. Top 5 Beneficial Owners',
        tableName: SECTION_1_TABLE_NAMES.BENEFICIALLY_OWNED_EQUITY_BY_TOP5_OWNERS
      },
      {
        name: '16. Investor Classification',
        tableName: SECTION_1_TABLE_NAMES.BENEFICIALLY_OWNED_EQUITY_INVESTORS
      },
      {
        name: '17. Performance',
        tableName: SECTION_1_TABLE_NAMES.GROSS_NET_PERFORMANCE
      },
      {
        name: '18. Identifiers',
        tableName: SECTION_1_TABLE_NAMES.FUND_IDENTIFYING_INFORMATION_Q18
      }
    ]
  },
  {
    name: 'Section 1c',
    id: '1c',
    key: '1c',
    questions: [
      {
        name: '19. Strategies',
        tableName: SECTION_1_TABLE_NAMES.STRATEGY_TYPE
      },
      {
        name: '20. Strategy classification',
        tableName: SECTION_1_TABLE_NAMES.STRATEGY_TYPE_NET_ASSET_VALUE_CAPITAL_ITEM
      },
      {
        name: '21. High-Frequency Trading',
        tableName: SECTION_1_TABLE_NAMES.STRATEGY_HIGH_FREQUENCY
      },
      {
        name: '22. Fund Exposure to Counterparties',
        tableName: SECTION_1_TABLE_NAMES.COUNTERPARTIES_PERCENT
      },
      {
        name: '23. Counterparty Exposure to Fund',
        tableName: SECTION_1_TABLE_NAMES.COUNTERPARTIES_DOLLAR
      },
      {
        name: '24. Trading Mechanisms',
        tableName: SECTION_1_TABLE_NAMES.TRADING_AND_CLEARING
      },
      {
        name: '25. Other Trading Mechanisms',
        tableName: SECTION_1_TABLE_NAMES.OTHER_TRANSACTION_PERCENT
      }
    ]
  },
  {
    name: 'Section 2b',
    id: '2b',
    key: '2b',
    questions: [
      {
        name: '29. Identifiers',
        tableName: SECTION_2_TABLE_NAMES.FUND_IDENTIFYING_INFORMATION_Q29
      },
      {
        name: '30. Asset Class Exposures',
        tableName: SECTION_2_TABLE_NAMES.HEDGE_FUND_EXPOSURE_TRADING
      },
      {
        name: '31. Base Currency',
        tableName: SECTION_2_TABLE_NAMES.BASE_CURRENCY_INFORMATION
      },
      {
        name: '32. Portfolio Liquidity',
        tableName: SECTION_2_TABLE_NAMES.LIQUIDITY
      },
      {
        name: '33. Unemcumbered Cash',
        tableName: SECTION_2_TABLE_NAMES.UNENCUMBERED_CASH
      },
      {
        name: '34. Open Positions',
        tableName: SECTION_2_TABLE_NAMES.OPEN_POSITIONS
      },
      {
        name: '35. Positions Exposures',
        tableName: SECTION_2_TABLE_NAMES.HEDGE_FUND_POSITIONS
      },
      {
        name: '36. Collateral Received',
        tableName: SECTION_2_TABLE_NAMES.HEDGE_FUND_COLLATERAL_Q36
      },
      {
        name: '37. Collateral Posted',
        tableName: SECTION_2_TABLE_NAMES.HEDGE_FUND_COLLATERAL_Q37
      },
      {
        name: '38. Rehypothecation',
        tableName: SECTION_2_TABLE_NAMES.REHYPOTHECATED_PERCENTAGE
      },
      {
        name: '39. CCP',
        tableName: SECTION_2_TABLE_NAMES.CLEAR_TRANSACTIONS_THROUGH_CCP
      },
      {
        name: '40. VaR',
        tableName: SECTION_2_TABLE_NAMES.VAR_CALCULATED_REGULARLY
      },
      {
        name: '40. VaR',
        tableName: SECTION_2_TABLE_NAMES.RISK_VAR_CALCULATED
      },
      {
        name: '41. Other Risk Metrics',
        tableName: SECTION_2_TABLE_NAMES.RISK_VAR_METRIC
      },
      {
        name: '42. Market Factors',
        tableName: SECTION_2_TABLE_NAMES.RISK_METRICS_BY_MARKET_FACTORS
      },
      {
        name: '43. (a)Unsecured Borrowing',
        tableName: SECTION_2_TABLE_NAMES.FINANCING_BORROWING_UNSECURED
      },
      {
        name: '43. (b)(i)Prime Brokerage Borrowing',
        tableName: SECTION_2_TABLE_NAMES.FINANCING_BORROWING_SECURED_1
      },
      {
        name: '43. (b)(ii)Reverse Repo Borrowing',
        tableName: SECTION_2_TABLE_NAMES.FINANCING_BORROWING_SECURED_2
      },
      {
        name: '43. (b)(iii)Other Secured Borrowing',
        tableName: SECTION_2_TABLE_NAMES.FINANCING_BORROWING_SECURED_3
      },
      {
        name: '44. Derivatives',
        tableName: SECTION_2_TABLE_NAMES.DERIVATIVE_POSITIONS
      },
      {
        name: '45. Derivative Collateral',
        tableName: SECTION_2_TABLE_NAMES.CCP_COLLATERAL
      },
      {
        name: '46. Financing Liquidity',
        tableName: SECTION_2_TABLE_NAMES.TOTAL_FINANCING
      },
      {
        name: '46. Financing Liquidity',
        tableName: SECTION_2_TABLE_NAMES.TOTAL_FINANCING_IN_DAYS
      },
      {
        name: '47. Creditors',
        tableName: SECTION_2_TABLE_NAMES.CREDITORS
      },
      {
        name: '48. Side-Pockets',
        tableName: SECTION_2_TABLE_NAMES.INVESTOR_INFORMATION
      },
      {
        name: '49. Investor Restrictions',
        tableName: SECTION_2_TABLE_NAMES.INVESTOR_WITHDRAWAL_REDEMPTION
      },
      {
        name: '50. Investor Liquidity',
        tableName: SECTION_2_TABLE_NAMES.INVESTOR_LIQUIDITY_DAYS
      }
    ]
  }
  // {
  //   name: 'Section 3',
  //   id: '3',
  //   key: '3',
  //   questions: [
  //     {
  //       name: '51.  Identifiers',
  //       tableName: SECTION_3_TABLE_NAMES.LIQUIDITY_FUND_INFO
  //     },
  //     {
  //       name: '52. Amortized Cost Method',
  //       tableName: SECTION_3_TABLE_NAMES.USE_AMORTIZED_COST_METHOD
  //     },
  //     {
  //       name: '53.  Penny Rounding',
  //       tableName: SECTION_3_TABLE_NAMES.USE_PENNY_ROUNDING_METHOD
  //     },
  //     {
  //       name: '54. Rule 2a-7',
  //       tableName: SECTION_3_TABLE_NAMES.COMPLY_RULE_2A7_POLICY
  //     },
  //     {
  //       name: '55. Net Assets',
  //       tableName: SECTION_3_TABLE_NAMES.LIQUIDITY_FUND_ASSETS
  //     },
  //     {
  //       name: '56. Borrowing',
  //       tableName: SECTION_3_TABLE_NAMES.LIQUIDITY_FUND_FINANCING
  //     },
  //     {
  //       name: '56. Borrowing',
  //       tableName: SECTION_3_TABLE_NAMES.BORROWING_DETAIL
  //     },
  //     {
  //       name: '57. Committed Liquidity',
  //       tableName: SECTION_3_TABLE_NAMES.STABLE_PRICE
  //     },
  //     {
  //       name: '58. Outstanding Shares',
  //       tableName: SECTION_3_TABLE_NAMES.INVESTOR_OUTSTANDING_SHARES_OF_STOCK
  //     },
  //     {
  //       name: '59. Investor Concentration',
  //       tableName: SECTION_3_TABLE_NAMES.BENEFICIALLY_OWNED_5_PERCENT_EQUITY_BY_INVESTORS
  //     },
  //     {
  //       name: '60. Securities Lending Collateral',
  //       tableName: SECTION_3_TABLE_NAMES.SECURITIES_LENDING_COLLATERAL
  //     },
  //     {
  //       name: '61. Investor Restrictions',
  //       tableName: SECTION_3_TABLE_NAMES.WITHDRAWAL_REDEMPTION_RESTRICTIONS
  //     },
  //     {
  //       name: '62. Investor Liquidity',
  //       tableName: SECTION_3_TABLE_NAMES.INVESTOR_LIQUIDITY
  //     },
  //     {
  //       name: '63. Portfolio Information',
  //       tableName: SECTION_3_TABLE_NAMES.PORTFOLIO
  //     },
  //     {
  //       name: '64. Side-by-side Investments',
  //       tableName: SECTION_3_TABLE_NAMES.MONEY_MARKET_FUND
  //     }
  //   ]
  // },
  // {
  //   name: 'Section 4',
  //   id: '4',
  //   key: '4',
  //   questions: [
  //     {
  //       name: '65. Identifiers',
  //       tableName: SECTION_4_TABLE_NAMES.PRIVATE_EQUITY
  //     },
  //     {
  //       name: '66. Guarantees',
  //       tableName: SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS1
  //     },
  //     {
  //       name: '67. Average Debt-to-Equity',
  //       tableName: SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS2
  //     },
  //     {
  //       name: '70. Portfolio Companies Gross Asset Value',
  //       tableName: SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS4
  //     },
  //     {
  //       name: '71. Portfolio Company Borrowings',
  //       tableName: SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS5
  //     },
  //     {
  //       name: '72. Portfolio Company Borrowings',
  //       tableName: SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS6
  //     },
  //     {
  //       name: '73. Portfolio Company Payment-in-kind and Zero Coupon Debt',
  //       tableName: SECTION_4_TABLE_NAMES.GUARANTEE_OBLIGATIONS7
  //     },
  //     {
  //       name: '74. Defaults',
  //       tableName: SECTION_4_TABLE_NAMES.DEFAULT_EVENT
  //     },
  //     {
  //       name: '75. Portfolio Company Bridge Loans',
  //       tableName: SECTION_4_TABLE_NAMES.BRIDGE_LOAN
  //     },
  //     {
  //       name: '75. Portfolio Company Bridge Loans',
  //       tableName: SECTION_4_TABLE_NAMES.FINANCING_LOANS
  //     },
  //     {
  //       name: '76. Financial Industry Portfolio Companies',
  //       tableName: SECTION_4_TABLE_NAMES.BRIDGE_LOAN_PERSONS_IS_FINANCIAL_INDUSTRY
  //     },
  //     {
  //       name: '76. Financial Industry Portfolio Companies',
  //       tableName: SECTION_4_TABLE_NAMES.CONTROL_PORTFOLIO_COMPANIES
  //     },
  //     {
  //       name: '77. Industry Breakdown',
  //       tableName: SECTION_4_TABLE_NAMES.PORTFOLIO_COMPANIES_BY_INDUSTRY
  //     },
  //     {
  //       name: '78. Geographical Breakdown',
  //       tableName: SECTION_4_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_REGION
  //     },
  //     {
  //       name: '78. Geographical Breakdown',
  //       tableName: SECTION_4_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY
  //     },
  //     {
  //       name: '79. Investment in Portfolio Companies',
  //       tableName: SECTION_4_TABLE_NAMES.INVESTED_AMOUNT
  //     }
  //   ]
  // }
];

export const managerSections = [
  {
    name: 'Section 1a',
    key: '1a',
    questions: [
      {
        name: '0. Filing type',
        tableName: SECTION_1_TABLE_NAMES.AIFM_FILING_TYPE
      },
      {
        name: '1. (a)Identifying information',
        tableName: SECTION_1_TABLE_NAMES.IDENT_INFO
      },
      {
        name: '1. (b)Related persons',
        tableName: SECTION_1_TABLE_NAMES.RELATED_PERSONS
      },
      {
        name: '2.1. Signature',
        tableName: SECTION_1_TABLE_NAMES.REPRESENTATIVE_SIGNATURE
      },
      {
        name: '2.2. Signature',
        tableName: SECTION_1_TABLE_NAMES.RELATED_PERSONS_SIGNATURE
      },
      {
        name: '3. RAUM and NAV',
        tableName: SECTION_1_TABLE_NAMES.AGGREGATED_ASSETS
      },
      {
        name: '4. Assumptions',
        tableName: SECTION_1_TABLE_NAMES.EXPLANATION
      }
    ]
  },
  {
    name: 'Section 2a',
    id: '2a',
    key: '2a',
    questions: [
      {
        name: '26. Aggregated Asset Class Exposures',
        tableName: SECTION_2_TABLE_NAMES.HEDGE_FUND_AGGREGATED_ASSETS_EXPOSURE
      },
      {
        name: '27. Aggregated Turnover',
        tableName: SECTION_2_TABLE_NAMES.TURNOVER
      },
      {
        name: '28. Aggregated Geographical Exposure',
        tableName: SECTION_2_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_REGION
      },
      {
        name: '28. Aggregated Geographical Exposure',
        tableName: SECTION_2_TABLE_NAMES.GEOGRAPHICAL_BREAKDOWN_BY_COUNTRY
      }
    ]
  }
];
